import React from "react";
import point from "./../../../../../Images/point.png";

const WhyEyeBrowBoost = () => {
  return (
    <div className="blogWhat-content">
      <h5>2. Boosts Confidence and Self-Esteem</h5>
      <p>
        There’s something undeniably powerful about well-groomed eyebrows. When
        your brows are in shape, your entire face looks put-together, which can
        have a huge impact on how you feel about yourself. Many people report
        feeling more confident after getting their eyebrows shaped, and it’s
        easy to see why.
      </p>
      <ul>
        <h4>How Eyebrow Shaping Boosts Confidence:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Instantly Enhances Appearance:{" "}
          </span>
          <p>
            Whether you’ve spent time perfecting your makeup or going
            bare-faced, well-shaped eyebrows instantly elevate your look.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Feels Fresh and Clean:{" "}
          </span>
          <p>
            Groomed brows give you that “freshly done” feeling, making you feel
            more polished and presentable in any situation.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Compliments from Others:{" "}
          </span>
          <p>
            Let’s face it—getting compliments on your brows feels great! Eyebrow
            shaping is a subtle change that can garner attention and positive
            feedback.
          </p>
        </li>
      </ul>
      <p>
        Confidence is one of the most attractive qualities anyone can have.
        Shaping your eyebrows, and feeling good about how you look, can have a
        ripple effect on your self-esteem, influencing how you carry yourself
        and interact with others.
      </p>
      <br />
    </div>
  );
};

export default WhyEyeBrowBoost;
